import MuiHidden from '@material-ui/core/Hidden';
var RcHidden = MuiHidden;
RcHidden.displayName = 'RcHidden';
export { RcHidden };
